"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const runningThreshold = .9;
exports.default = runningThreshold;
